import React from 'react';

import {
  deleteCommunityComment,
  getCommunityComments,
  postCommunityComment,
  updateCommunityComment,
} from 'apis/CommunityAPI';
import { useAppSelector } from 'store/hook';

import CommentsSection from './CommentsSection';
import { useCommunityInfoContext } from '../../CommunityInfoContext';

const COMMUNITY_COMMENTS_QUERY_KEY_SCOPE = 'community';
const COMMUNITY_COMMENTS_TEST_ID_PREFIX = 'cd-community-comments';

const Comments = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const { communityInfo } = useCommunityInfoContext();

  return (
    <CommentsSection
      entityId={communityInfo?.id}
      queryKeyScope={COMMUNITY_COMMENTS_QUERY_KEY_SCOPE}
      currentUserId={currentUser?.user_id}
      currentUserAvatarUrl={currentUser?.avatar}
      currentUserName={currentUser?.FullName}
      dataTestIdPrefix={COMMUNITY_COMMENTS_TEST_ID_PREFIX}
      getComments={getCommunityComments}
      postComment={postCommunityComment}
      updateComment={updateCommunityComment}
      deleteComment={deleteCommunityComment}
    />
  );
};

export default Comments;
